(function () {
  let Main = {};

  let duracion = 400;

  let breakpoint = 576;
  let formato = "horizontal";

  Main.init = function () {
    function setup() {
      d3.timeFormatDefaultLocale({
        dateTime: "%x, %X",
        date: "%d/%m/%Y",
        time: "%-I:%M:%S %p",
        periods: ["AM", "PM"],
        days: [
          "domingo",
          "lunes",
          "martes",
          "miércoles",
          "jueves",
          "viernes",
          "sábado",
        ],
        shortDays: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        months: [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre",
        ],
        shortMonths: [
          "ene",
          "feb",
          "mar",
          "abr",
          "may",
          "jun",
          "jul",
          "ago",
          "sep",
          "oct",
          "nov",
          "dic",
        ],
      });
      setFormato();
      tippy.setDefaults({
        animation: "fade",
        arrow: true,
      });
      main();
    }

    function setFormato() {
      let w = document.documentElement.clientWidth;
      formato = w > breakpoint ? "horizontal" : "vertical";
    }

    function main() {
      generaGraficas();
    }

    function getParams(params) {
      return Object.assign({ duracion: duracion, formato: formato }, params);
    }

    function generaGraficas() {
      let scatterplots = d3.selectAll("div[data-chart='scatter']");
      scatterplots.each(function (d, i) {
        let el = d3.select(this);
        let data = Data.getDataScatter();
        Chart.scatterplot(getParams({ el: el, data: data }));
      });

      let scatterplots2 = d3.selectAll("div[data-chart='scatter2']");
      scatterplots2.each(function (d, i) {
        let el = d3.select(this);
        let data = Data.getDataScatter();
        Chart.scatterplot2(getParams({ el: el, data: data }));
      });

      let anillos = d3.selectAll("div[data-chart='rings']");
      anillos.each(function (d, i) {
        let el = d3.select(this);
        let data = Data.getData();
        Chart.rings(getParams({ el: el, data: data }));
        console.log(0);
      });

      let anillosEstaticos = d3.selectAll("div[data-chart='rings-static']");
      anillosEstaticos.each(function (d, i) {
        let el = d3.select(this);
        let data = Data.getData();
        Chart.ringsStatic(getParams({ el: el, data: data }));
      });

      let radiales = d3.selectAll("div[data-chart='spiral-grid']");
      radiales.each(function (d, i) {
        let el = d3.select(this);
        let defunciones = Data.getDefuncion();
        Chart.spiralGrid(getParams({ el: el, data: defunciones }));
      });

      radiales = d3.selectAll("div[data-chart='spiral-grid-infants']");
      radiales.each(function (d, i) {
        let el = d3.select(this);
        let defunciones = Data.getDefuncion();
        Chart.spiralGridInfants(getParams({ el: el, data: defunciones }));
      });

      radiales = d3.selectAll("div[data-chart='spiral-grid-hospital']");
      radiales.each(function (d, i) {
        let el = d3.select(this);
        let hospitalizaciones = Data.getHospitalizaciones();
        Chart.spiralGridHospitals(
          getParams({ el: el, data: hospitalizaciones }),
        );
      });
    }

    setup();
  };

  windowReady.ready(function () {
    Main.init();
  });
})();
/*
if (typeof Main !== " function") {
  let Main = function () {
    let duracion = 400;

    let breakpoint = 576;
    let formato = "horizontal";

    function fetchData() {
      let estados = Window.data.json.estados;
      let params = {};
      params.estados = estados;

      procesaData(params);
    }

    function procesaData(params) {
      generaGraficas(params);
    }

    function generaGraficas(params) {
      let elMapa = d3.select("#mapa_contagios") || false;
      if (!elMapa.empty()) {
        let mapa = new Mapa(elMapa, duracion, formato, {
          estados: params.estados,
        });
        delete window.Mapa;
      }
    }

    function setup() {
      //https://unpkg.com/d3-time-format@2.3.0/locale/es-MX.json
      d3.timeFormatDefaultLocale({
        dateTime: "%x, %X",
        date: "%d/%m/%Y",
        time: "%-I:%M:%S %p",
        periods: ["AM", "PM"],
        days: [
          "domingo",
          "lunes",
          "martes",
          "miércoles",
          "jueves",
          "viernes",
          "sábado",
        ],
        shortDays: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        months: [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre",
        ],
        shortMonths: [
          "ene",
          "feb",
          "mar",
          "abr",
          "may",
          "jun",
          "jul",
          "ago",
          "sep",
          "oct",
          "nov",
          "dic",
        ],
      });
      setFormato();
      fetchData();
    }

    function setFormato() {
      let w = document.documentElement.clientWidth;
      formato = w > breakpoint ? "horizontal" : "vertical";
    }

    setup();
  };

  windowReady.ready(function () {
    let charts = new Main();
  });
}
*/
